export default {
  name: 'stjärna',
  title: 'Polygon/stjärnverktyg',
  buttons: [
    {
      title: 'Stjärnverktyg'
    },
    {
      title: 'Polygonverktyg'
    }
  ],
  contextTools: [
    {
      title: 'Antal sidor',
      label: 'poäng'
    },
    {
      title: 'Pointiness',
      label: 'Pointiness'
    },
    {
      title: 'Vrider stjärnan',
      label: 'Radiell förskjutning'
    },
    {
      title: 'Antal sidor',
      label: 'sidor'
    }
  ]
}
